import Navbar from "../components/NavBar";
import Banner from "../components/Banner";
import Content from "../components/Content";
import Footer from "../components/Footer";


const Automotive = () => {


  return (
    <div className="">
      <Navbar />
        <Banner />
        <div className="App-header">
          <div className="container-md">
            <Content />
          </div>
        </div>
      <Footer />
    </div>
  );
};

export default Automotive;
